'use strict';

import {find, register} from '../../../JavaScript/Utils';

const AccordionItem = $el => {
    const toggle = find('[data-nezzo-accordion-toggle]', $el);
    const toggleItem = find('[data-nezzo-accordion-toggle-item]', $el);

    toggle.addEventListener('click', () => {
        toggle.classList.toggle('open');
        toggleItem.classList.toggle('open');
    });
    
};

register('AccordionItem', AccordionItem);
